import { h, Component, Fragment } from 'preact';
import noaaBadgeImage from './../../assets/noaa-badge-full-color.svg';
import hawaiiSealImage from './../../assets/hawaii-seal.png';
import tsunamiMitigationImage from './../../assets/tsunami-mitigation-logo.png';
import primoLogo from './../../assets/primo-logo.png';

export default class FooterComponent extends Component {
    constructor() {
        super();
        this.hawaiiCode = 'hi';
        this.guamCode = 'gu';
        this.state = {
            hasBeenOpened: false
        };
    }

    getClass() {
        if (this.props.isOpen) {
            if (!this.state.hasBeenOpened) {
                this.setState({ hasBeenOpened: true });
            }
            return 'slide-panel-bottom-show';
        }
        else if (this.props.isOpen === false && this.state.hasBeenOpened) {
            return 'slide-panel-bottom-hide';
        }
        else {
            return '';
        }
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <footer class={`footer ${self.getClass()}`}>
                    <div class="footer-inner">
                        <button role="button" class="btn-close--dark" onclick={self.props.close}>&times;</button>
                        <div class="column">
                            <h4>About this Map</h4>
                            {this.props.currentLocation === this.hawaiiCode &&
                                [<p>This map depicts the tsunami evacuation zones developed by your local emergency management or county civil defense agency. These evacuation zones provide the minimum safe evacuation distance.</p>,
                                    <p>This information is also available in your local telephone directory and from your county civil defense agency.</p>]
                            }
                            {this.props.currentLocation === this.guamCode &&
                                [<p>This map depicts the tsunami evacuation zones (shaded in pink) developed by your local emergency management agency. These evacuation zones provide the minimum safe evacuation distance.</p>,
                                    <p>This information is also available in your local telephone directory and from your emergency management agency.</p>]
                            }

                            <p>In the event of a locally generated tsunami, you may only have minutes to evacuate. If the ground is shaking, a locally generated tsunami may be occurring. Move to higher ground immediately, well away from the evacuation zone and low-lying coastal areas.</p>

                            <p>
                                Website Owner: <a href="https://coast.noaa.gov/" target="_blank" rel="noreferrer">NOAA Office for Coastal Management </a>
                                <br />
                                Page Reviewed: November 12, 2015
                            </p>

                        </div>

                        <div class="column">

                            <h4>About this Site</h4>

                            <p>This site has been developed by the <a href="http://www.tsunami.noaa.gov/" title="Go to tsunami.noaa.gov" target="_blank" rel="noreferrer">National Oceanic and Atmospheric Administration</a> (NOAA) in partnership with the State of Hawai'i.
                            </p>

                            <p>
                                <a href="https://coast.noaa.gov/survey.html" target="_blank" rel="noreferrer">Customer Satisfaction Survey</a>
                            </p>

                            <p>
                                <a href="mailto:psc@noaa.gov?subject=Feedback from Tsunami" title="Email Feedback" target="_blank" rel="noreferrer">For feedback, contact the NOAA Office for Coastal Management - Pacific Islands</a>
                            </p>

                            <p>
                                <a href="//coast.noaa.gov/PrivacyPolicy/privacyPolicy.html" title="Privacy Policy" target="_blank" rel="noreferrer">Privacy Policy</a>
                            </p>

                            <p>
                                <a href="javascript:alert('The data and maps in this tool illustrate the scale of potential inundation from a hypothetical tsunami, not the exact location, and do not account for all physical or anthropogenic processes. The data and maps in this tool are provided “as is,” without warranty to their performance, merchantable state, or fitness for any particular purpose. The entire risk associated with the results and performance of these data is assumed by the user. This tool should be used strictly as an evacuation planning reference tool and not for navigation, permitting, or other legal purposes.');" >Disclaimer</a>
                            </p>

                            <p>
                                <a href="//coast.noaa.gov/ocm-accessibility-disclaimer.html" target="_blank" rel="noreferrer" title="Accessibility Statement">Accessibility Statement</a>
                            </p>

                            <p>
                                <a href="//coast.noaa.gov/digitalcoast" target="_blank" rel="noreferrer" title="Visit Site">Provided by NOAA's DigitalCoast</a>
                            </p>
                            <a href="https://noaa.gov" title="Go to noaa.gov" target="_blank" rel="noreferrer" class="partner-logo">
                                <img src={noaaBadgeImage} alt="NOAA logo" width="80" />
                            </a>

                            <a href="https://www.scd.hawaii.gov/" title="Go to State of Hawaii site" target="_blank" rel="noreferrer" class="partner-logo">
                                <img src={hawaiiSealImage} alt="Seal of the State of Hawaii" width="80" height="80" />
                            </a>

                            <a href="https://nws.weather.gov/nthmp/" title="Go to Tsunami Hazard Mitigation Program website" target="_blank" rel="noreferrer" class="partner-logo">
                                <img src={tsunamiMitigationImage} alt="Tsunami Hazard Mitigation Program Logo" />
                            </a>

                            <a href="https://coast.noaa.gov/primo/" title="Go to Primo website" target="_blank" rel="noreferrer" class="partner-logo">
                                <img src={primoLogo} alt="Primo Logo" width="80" />
                            </a>
                        </div>
                    </div>
                </footer>
            </Fragment>
        );
    }
}
